



































import { PropType, defineComponent } from '@vue/composition-api';
import { createNamespacedHelpers, useStore } from 'vuex-composition-helpers';

import { IWorkflowTransitionAction } from '@/models';
import { IRootState } from '@/store';
import {
  IWorkflowStoreState,
  IWorkflowGetters,
  IWorkflowActions,
  IWorkflowMutations
} from '@/store/workflow';

import auth from '@/mixins/auth';

import WorkflowTransitionActionDeleteOption from './WorkflowTransitionActionDeleteOption.vue';

export default defineComponent({
  name: 'WorkflowTransitionActionDetail',

  components: {
    WorkflowTransitionActionDeleteOption
  },

  props: {
    workflowId: {
      type: Number,
      required: true
    },

    transitionId: {
      type: Number,
      required: true
    },

    disabled: {
      type: Boolean
    },

    action: {
      type: Object as PropType<IWorkflowTransitionAction>,
      required: true
    }
  },

  mixins: [auth],

  setup() {
    const store = useStore<IRootState>();

    const { useGetters } = createNamespacedHelpers<
      IWorkflowStoreState,
      IWorkflowGetters,
      IWorkflowActions,
      IWorkflowMutations
    >(store, 'workflow');

    const { getWorkflowTransitionActionTypeVisualByType } = useGetters([
      'getWorkflowTransitionActionTypeVisualByType'
    ]);

    return {
      getWorkflowTransitionActionTypeVisualByType
    };
  }
});
